var _excluded = ["name", "className", "iconSet", "size", "as", "block", "aria-label"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { Focusable } from "@xo-union/ui-accessibility";
import defaultIconSet from "../../icon-sets/v2/index.js";
import styles from "../../css/interactive-icon.css";
import Icon from "../Icon/index.js";
var InteractiveIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var name = _ref.name,
    className = _ref.className,
    iconSet = _ref.iconSet,
    size = _ref.size,
    Type = _ref.as,
    block = _ref.block,
    ariaLabel = _ref['aria-label'],
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = [className, styles.container, block ? styles['is-block'] : styles['is-inline'], size ? styles["size-".concat(size)] : ''];
  return /*#__PURE__*/React.createElement(Focusable, _extends({
    ref: ref,
    as: Type,
    className: classes.join(' ')
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, props), /*#__PURE__*/React.createElement(Icon, _extends({
    name: name,
    iconSet: iconSet,
    size: size
  }, ariaLabel && {
    'aria-hidden': true
  })));
});
process.env.NODE_ENV !== "production" ? InteractiveIcon.propTypes = {
  /**
   * Name of the icon to render in the anchor tag
   */
  name: PropTypes.string.isRequired,
  /**
   * Component to wrap Icon with; or string to represent valid html tag (e.g. 'a')
   */
  as: PropTypes.elementType,
  /**
   * Whether to render interactive container as a block element.
   */
  block: PropTypes.bool,
  /**
   * Class names for styling the component
   */
  className: PropTypes.string,
  /**
   * The icon set to use
   */
  iconSet: PropTypes.shape({
    resolve: PropTypes.func.isRequired
  }),
  /**
   * A size class. See the size table for more info.
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /**
   * Accessible short description. If provided, the icon will be hidden from the accessibility tree.
   */
  'aria-label': PropTypes.string
} : void 0;
InteractiveIcon.defaultProps = {
  className: '',
  block: false,
  iconSet: defaultIconSet,
  size: null,
  'aria-label': null
};
InteractiveIcon.displayName = 'InteractiveIcon';
export default InteractiveIcon;